export default __webpack_public_path__ + "static/media/siddha.2190f207.webp";